import { useContext } from "react";
import styles from "./Intro.module.css";

import { Heading, CopyText, Asterisk } from "@dtpk-cc/components";

import "@dtpk-cc/components/dist/global.css";
import "@dtpk-cc/components/dist/components/Heading/Heading.css";
import "@dtpk-cc/components/dist/components/CopyText/CopyText.css";
import "@dtpk-cc/components/dist/components/Asterisk/Asterisk.css";

import { ModalContext } from '../../contexts/ModalContext';

export default function Intro(){
  const { setIsModalOpen, setFnId } = useContext(ModalContext);
  
  const openModal = (fnId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFnId(fnId);
    setIsModalOpen(true);
  };

  return (
    <div className={styles.container}>
      <Heading variants={[Heading.Variant.secondary, styles.heading]}>Schnelles Internet für Ihr Zuhause ...</Heading>
      <CopyText>
        Für Ihre Treue möchten wir Ihnen danken – mit unseren <b>Magenta</b>Zuhause Tarifen zum exklusiven Sonderpreis:
        Genießen Sie Highspeed-Internet für nur 19,95 &euro;
        <matrix-asterisk matrix-id="8tPQUh"></matrix-asterisk>
        mtl. in den ersten 3 Monaten.
        Unser erstklassiger Service ist natürlich wie immer inklusive.
      </CopyText>
    </div>
  );
}